module.exports = __webpack_public_path__ + "img/tick_purple.6966396e.svg";